import React from "react";
import classes from './VerticalMenu.module.css';


const MenuBtns = ({setCurrentMenuIndex, children, currentContentIndexState, setCurrentContentIndexState, disableOnClick = false }) => {

    function handleClick(index) {
        if (!disableOnClick) {
            children[index].props.onClick && children[index].props.onClick()
            setCurrentContentIndexState(index)
            setCurrentMenuIndex && setCurrentMenuIndex(index)
        }
    }

    return (
        <>
            <div className={classes.MenuBtns}>
                <div className={classes.AllActionBtn}>
                    {children.map((x, i) =>
                        <button key={i} disabled={x.props && x.props.disable} onClick={() => handleClick(i)} className={`${disableOnClick && classes.disable} ${classes.ActionBtn} ${currentContentIndexState === i && classes.CurrentActionBtn}`}>{x.props && x.props.title}</button>
                    )}
                </div>
            </div>
        </>
    )
}

export default MenuBtns;